// The web stand-in for a share sheet: the card itself, its text, and three
// plain actions. Native builds never see this; the OS sheet takes the file.
export function SharePreview({ url, text, fileName, onClose }: {
  url: string; text: string; fileName: string; onClose: () => void;
}) {
  return (
    <div className="share-preview" role="dialog" aria-label="Share card" onClick={onClose}>
      <div className="share-preview-box" onClick={(e) => e.stopPropagation()}>
        <img src={url} alt="Your share card" />
        <pre>{text}</pre>
        <div className="share-preview-actions">
          <button className="btn btn-primary" onClick={async () => { try { await navigator.clipboard.writeText(text); } catch { /* blocked */ } }}>COPY TEXT</button>
          <a className="btn btn-ghost" href={url} download={fileName}>SAVE IMAGE</a>
          <button className="btn btn-ghost" onClick={onClose}>CLOSE</button>
        </div>
      </div>
    </div>
  );
}
